import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldX, Loader2 } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const Field = ({ label, value, testId, mono }) => (
  <div className="py-3 border-b last:border-0">
    <div className="text-[11px] font-bold uppercase tracking-wider text-gray-500">{label}</div>
    <div className={`mt-0.5 text-base ${mono ? "font-mono" : "font-medium"}`} data-testid={testId}>{value || "—"}</div>
  </div>
);

export default function VerifyCertificate() {
  const { token } = useParams();
  const [c, setC] = useState(undefined);
  useEffect(() => {
    api.get(`/certificates/verify/${encodeURIComponent(token)}`).then((r) => setC(r.data)).catch(() => setC(null));
  }, [token]);
  return (
    <div className="min-h-screen bg-[#F8F9FA] grid place-items-center p-4" data-testid="verify-certificate-page">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden border-t-4 border-[#E60000]">
        <div className="p-6 flex items-center gap-3 border-b">
          <img src="/images/gamls-logo.png" alt="GAMLS" className="w-12 h-12 object-contain" />
          <div><div className="font-heading font-bold">Certificate verification</div><div className="text-xs text-gray-500">Ghana Association of Medical Laboratory Scientists</div></div>
        </div>
        {c === undefined ? <div className="p-10 grid place-items-center"><Loader2 className="w-6 h-6 animate-spin text-gray-400" /></div> : c ? (
          <div className="p-6">
            <div className="flex items-center gap-2 bg-emerald-50 text-emerald-800 rounded-lg p-3 font-semibold" data-testid="verify-valid"><ShieldCheck className="w-5 h-5" />This certificate is original and was issued by GAMLS.</div>
            <div className="mt-4">
              <Field label="Participant" value={c.name} testId="verify-name" />
              <Field label="Event" value={c.event_title} testId="verify-event" />
              <Field label="Event date" value={[c.event_date, c.event_venue].filter(Boolean).join(" · ")} testId="verify-date" />
              <Field label="Category" value={c.category_name} testId="verify-category" />
              <Field label="Serial number" value={c.serial} testId="verify-serial" mono />
              <Field label="Issued" value={fmtDate(c.issued_at)} testId="verify-issued" />
            </div>
          </div>
        ) : (
          <div className="p-6"><div className="flex items-center gap-2 bg-red-50 text-[#B30000] rounded-lg p-3 font-semibold" data-testid="verify-invalid"><ShieldX className="w-5 h-5" />We could not find this certificate. It may not be genuine.</div></div>
        )}
      </div>
    </div>
  );
}
